import React, { useMemo } from 'react'
import { FaRegCalendar, FaUserAlt, FaUsers } from 'react-icons/fa'
import { GoGear } from 'react-icons/go'
import { MdMenu, MdOutlineDashboard } from 'react-icons/md'
import logo from '../../assets/logo-branco.png'
import { BRAND_FALLBACK } from '../../context/theme'
import { brandOnDark, brandShade } from '../../utilities/brandColors'
import { chartPalette } from '../../utilities/dashboard'

// Atendimentos por mês (ano anterior e ano base), só para mostrar as cores dos gráficos
const BARS = [[38, 52], [46, 60], [30, 44], [54, 70], [42, 64], [50, 80]]

// Miniatura do portal (topo, menu lateral com o submenu aberto e uma tela do Dashboard) no tema 'light' ou 'dark', com a cor
// escolhida. O data-bs-theme aplica as cores do theme.css do tema; a marca entra no lugar da cor salva, como o theme.js faz
const MenuPreview = ({ color, theme, label }) => {
  const colors = useMemo(() => ({
    shade: brandShade(color, BRAND_FALLBACK),
    onDark: brandOnDark(color, BRAND_FALLBACK),
    chart: chartPalette(theme, color).chart,
  }), [color, theme])

  return (
    <figure className='menu-preview-figure m-0'>
      <figcaption className='small text-muted mb-1'>{label}</figcaption>
      <div
        className='menu-preview'
        data-bs-theme={theme}
        data-testid={`menu-preview-${theme}`}
        style={{ '--app-brand': color, '--app-brand-on-dark': colors.onDark, '--menu-preview-shade': colors.shade }}
        aria-hidden='true'
      >
        <div className='menu-preview-top'>
          <MdMenu size={14} />
          <span className='d-flex align-items-center gap-1'><FaUserAlt size={9} /> USUÁRIO</span>
        </div>

        <div className='menu-preview-body'>
          <div className='menu-preview-aside'>
            <span><MdOutlineDashboard /> Dashboard</span>
            <span><FaRegCalendar /> Agenda</span>
            <span><FaUsers /> Pacientes</span>
            <div className='menu-preview-group'>
              <span><GoGear /> Configurações</span>
              <span className='menu-preview-sub'>Status</span>
              <span className='menu-preview-sub'>Menu</span>
            </div>
            <img src={logo} alt='' className='menu-preview-logo' />
          </div>

          <div className='menu-preview-content'>
            <span className='menu-preview-title'>Dashboard</span>
            <div className='menu-preview-card'>
              <div className='d-flex justify-content-between align-items-center gap-2'>
                <span className='menu-preview-card-title'>Atendimentos por mês</span>
                <span className='menu-preview-link'>Ver todos</span>
              </div>
              <div className='menu-preview-bars'>
                {BARS.map(([previous, current], index) => (
                  <div key={index} className='menu-preview-bar-pair'>
                    <i style={{ height: `${previous}%`, background: colors.chart.previous }} />
                    <i style={{ height: `${current}%`, background: colors.chart.primary }} />
                  </div>
                ))}
              </div>
              <div className='d-flex gap-1'>
                <span className='menu-preview-pill active'>Hoje</span>
                <span className='menu-preview-pill'>Semana</span>
                <span className='menu-preview-pill'>Mês</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </figure>
  )
}

export default MenuPreview
